
const detectEnvironment = () => {
  if (import.meta.env.VITE_ENVIRONMENT) {
    return import.meta.env.VITE_ENVIRONMENT;
  }

  const hostname = window.location.hostname;

  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'development';
  }

  if (hostname === 'stg-admin.posture.vision' || hostname === '3.79.18.212') {
    return 'staging';
  }

  return 'production';
}

export const getWebsiteBackendUrl = () => {
  const env = detectEnvironment();

  // Check for explicit environment variable override
  if (import.meta.env.VITE_API_BASE_URL) {
    return import.meta.env.VITE_API_BASE_URL;
  }

  switch (env) {
    case 'development':
      return 'http://localhost:8000';
    case 'staging':
      return 'https://staging-api.posture.vision';
    case 'production':
    default:
      return 'https://api.posture.vision';
  }
}

export const getMLBackendUrl = () => {
  const env = detectEnvironment();

  if (import.meta.env.VITE_ML_API_BASE_URL) {
    return import.meta.env.VITE_ML_API_BASE_URL;
  }

  switch (env) {
    case 'development':
      return import.meta.env.VITE_ML_LOCAL === 'true'
        ? 'http://localhost:8001'
        : 'https://staging-api.posture.vision';
    case 'staging':
      return 'https://staging-api.posture.vision';
    case 'production':
    default:
      return 'https://staging-api.posture.vision';
  }
}

export const getMLWebSocketUrl = () => {
  const httpUrl = getMLBackendUrl();
  // Convert HTTP(S) to WS(S)
  if (httpUrl.startsWith('https://')) {
    return httpUrl.replace('https://', 'wss://');
  } else if (httpUrl.startsWith('http://')) {
    return httpUrl.replace('http://', 'ws://');
  }

  return httpUrl;
}

/**
 * Get the current environment
 */
export const getCurrentEnvironment = () => {
  return detectEnvironment();
}

/**
 * Check if running in development mode
 */
export const isDevelopment = () => {
  return detectEnvironment() === 'development';
}

/**
 * Check if running in staging mode
 */
export const isStaging = () => {
  return detectEnvironment() === 'staging';
}

/**
 * Check if running in production mode
 */
export const isProduction = () => {
  return detectEnvironment() === 'production';
}

// Export constants for easy access
export const WEBSITE_BACKEND_URL = getWebsiteBackendUrl();
export const ML_BACKEND_URL = getMLBackendUrl();
export const ML_WEBSOCKET_URL = getMLWebSocketUrl();
export const CURRENT_ENVIRONMENT = getCurrentEnvironment();

// Export a config object with all URLs
export const BackendConfig = {
  // Website Backend (REST API)
  websiteApi: WEBSITE_BACKEND_URL,

  // ML Backend URLs
  mlApi: ML_BACKEND_URL,
  mlWebSocket: ML_WEBSOCKET_URL,

  // Environment info
  environment: CURRENT_ENVIRONMENT,
  isDevelopment: isDevelopment(),
  isStaging: isStaging(),
  isProduction: isProduction(),

  // Helper methods
  getWebsiteBackendUrl,
  getMLBackendUrl,
  getMLWebSocketUrl,
};

export default BackendConfig;